import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { Table, Button, Modal, Input, notification, Popconfirm } from 'antd';
import { PlusOutlined, EditOutlined, DeleteOutlined } from '@ant-design/icons';
import Sidebar from '../../components/Sidebar/Sidebar';
import Header from '../../components/Header/Header';
import withRoleAccess from '../../hoc/withRoleAccess';

const BranchControlPage = () => {
  const API_URL = process.env.REACT_APP_API_URL;
  const [branches, setBranches] = useState([]);
  const [loading, setLoading] = useState(true);
  const [modalVisible, setModalVisible] = useState(false);
  const [isEditing, setIsEditing] = useState(false);
  const [editingBranchId, setEditingBranchId] = useState(null);

  const [formData, setFormData] = useState({
    name: '',
    code: '',
    address: '',
    phone: '',
    email: ''
  });

  const fetchBranches = async () => {
    try {
      const token = localStorage.getItem('token');
      const response = await axios.get(`${API_URL}/branch`, {
        headers: { Authorization: `Bearer ${token}` }
      });
      setBranches(response.data);
      setLoading(false);
    } catch (err) {
      console.error('Error fetching branches:', err);
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchBranches();
  }, []);

  const handleSave = async () => {
    try {
      const token = localStorage.getItem('token');
      if (isEditing) {
        await axios.put(`${API_URL}/branch/${editingBranchId}`, formData, {
          headers: { Authorization: `Bearer ${token}` }
        });
        notification.success({ message: 'Branch updated successfully' });
      } else {
        await axios.post(`${API_URL}/branch`, formData, {
          headers: { Authorization: `Bearer ${token}` }
        });
        notification.success({ message: 'Branch created successfully' });
      }
      setModalVisible(false);
      fetchBranches();
    } catch (err) {
      console.error('Error saving branch:', err);
      notification.error({ message: 'Failed to save branch' });
    }
  };

  const handleDelete = async (id) => {
    try {
      const token = localStorage.getItem('token');
      await axios.delete(`${API_URL}/branch/${id}`, {
        headers: { Authorization: `Bearer ${token}` }
      });
      notification.success({ message: 'Branch deleted successfully' });
      fetchBranches();
    } catch (err) {
      console.error('Error deleting branch:', err);
      notification.error({ message: 'Failed to delete branch' });
    }
  };

  const columns = [
    { title: 'ID', dataIndex: 'id', key: 'id' },
    { title: 'Name', dataIndex: 'name', key: 'name' },
    { title: 'Code', dataIndex: 'code', key: 'code' },
    { title: 'Address', dataIndex: 'address', key: 'address' },
    { title: 'Phone', dataIndex: 'phone', key: 'phone' },
    { title: 'Email', dataIndex: 'email', key: 'email' },
    {
      title: 'Actions',
      key: 'actions',
      render: (_, record) => (
        <>
          <Button
            type="link"
            icon={<EditOutlined />}
            onClick={() => {
              setFormData(record);
              setEditingBranchId(record.id);
              setIsEditing(true);
              setModalVisible(true);
            }}
          />
          <Popconfirm
            title="Are you sure delete this branch?"
            onConfirm={() => handleDelete(record.id)}
          >
            <Button type="link" danger icon={<DeleteOutlined />} />
          </Popconfirm>
        </>
      )
    }
  ];

  return (
    <div>
      <Sidebar />
      <Header />
      <div className="dashboard-content">
        <h1>Branch Management</h1>
        <Button
          type="primary"
          icon={<PlusOutlined />}
          onClick={() => {
            setFormData({ name: '', code: '', address: '', phone: '', email: '' });
            setIsEditing(false);
            setModalVisible(true);
          }}
          style={{ marginBottom: 16 }}
        >
          Add Branch
        </Button>
        <Table
          dataSource={branches}
          columns={columns}
          rowKey="id"
          loading={loading}
        />

        <Modal
          title={isEditing ? 'Edit Branch' : 'Add Branch'}
          open={modalVisible}
          onOk={handleSave}
          onCancel={() => setModalVisible(false)}
          okText={isEditing ? 'Save' : 'Create'}
        >
          <Input
            placeholder="Name"
            value={formData.name}
            onChange={(e) => setFormData({ ...formData, name: e.target.value })}
            style={{ marginBottom: 8 }}
          />
          <Input
            placeholder="Code"
            value={formData.code}
            onChange={(e) => setFormData({ ...formData, code: e.target.value })}
            style={{ marginBottom: 8 }}
          />
          <Input
            placeholder="Address"
            value={formData.address}
            onChange={(e) => setFormData({ ...formData, address: e.target.value })}
            style={{ marginBottom: 8 }}
          />
          <Input
            placeholder="Phone"
            value={formData.phone}
            onChange={(e) => setFormData({ ...formData, phone: e.target.value })}
            style={{ marginBottom: 8 }}
          />
          <Input
            placeholder="Email"
            value={formData.email}
            onChange={(e) => setFormData({ ...formData, email: e.target.value })}
            style={{ marginBottom: 8 }}
          />
        </Modal>
      </div>
    </div>
  );
};

export default withRoleAccess(BranchControlPage, ['superadmin']);
